var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimetracking = function SvgTimetracking(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.3 1.5h227.1v102.6H387.3zM500 126.7C259 126.7 63.8 322 63.8 562.9S259 999.1 500 999.1s436.2-195.3 436.2-436.2S741 126.7 500 126.7m-.9 518.7c-43.6 0-78.9-35.3-78.9-78.9 0-30.2 17-56.4 41.9-69.7V279.5H538v218.1c5.2 3 10 6.6 14.3 10.7 15.8 14.4 25.7 35.2 25.7 58.2 0 43.5-35.4 78.9-78.9 78.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M868.3 252.8c-10.9 0-21.3-4.3-28.9-12L798.5 200c-16-16-16-41.9 0-57.8 16-16 41.9-16 57.8 0l40.9 40.9c16 16 16 41.9 0 57.8-7.6 7.7-18 12-28.9 11.9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimetracking);
export default ForwardRef;